import axios from 'axios';
import StorageService from '../services/StorageService';

class UserHttpService {
    static async findById(id) {
        try {
            const response = await axios.get(
                `${process.env.REACT_APP_API_BASE_URL}/users/findbyid/${id}`,
                {
                    headers: {
                        'Accept': 'application/json',
                        'Authorization': `Bearer ${StorageService.getAuth()?.token ?? ''}`
                    }
                }
            );
            return response.data;
        } catch (error) {
            throw error.response?.data || error;
        }
    }

    static async getDashboardData() {
        try {
            const response = await axios.get(
                `${process.env.REACT_APP_API_BASE_URL}/dashboard`,
                {
                    headers: {
                        Authorization: `Bearer ${StorageService.getAuth()?.token ?? ''}`
                    }
                }
            );
            return response.data;
        } catch (error) {
            throw error.response?.data || error;
        }
    }

    static async getUsers(page = 1, limit = 10, search = '') {
        try {
            const response = await axios.get(
                `${process.env.REACT_APP_API_BASE_URL}/users?page=${page}&limit=${limit}&search=${search}`,
                {
                    headers: {
                        'Accept': 'application/json',
                        'Authorization': `Bearer ${StorageService.getAuth()?.token ?? ''}`
                    }
                }
            );
            return response.data;
        } catch (error) {
            throw error.response?.data || error;
        }
    }

    static async getInsurance() {
        try {
            const response = await axios.get(
                `${process.env.REACT_APP_API_BASE_URL}/user/insurance`,
                {
                    headers: {
                        'Accept': 'application/json',
                        'Authorization': `Bearer ${StorageService.getAuth()?.token ?? ''}`
                    }
                }
            );
            return response.data;
        } catch (error) {
            throw error.response?.data || error;
        }
    }

    static async updateInsurance(insurance) {
        try {
            const response = await axios.post(
                `${process.env.REACT_APP_API_BASE_URL}/user/insurance`,
                {insurance},
                {
                    headers: {
                        'Accept': 'application/json',
                        'Authorization': `Bearer ${StorageService.getAuth()?.token ?? ''}`
                    }
                }
            );
            return response.data;
        } catch (error) {
            throw error.response?.data || error;
        }
    }

    static async uploadUsersCSV(formData) {
        try {
            const response = await axios.post(
                `${process.env.REACT_APP_API_BASE_URL}/users/upload`,
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                        'Authorization': `Bearer ${StorageService.getAuth()?.token ?? ''}`
                    }
                }
            );
            return response.data;
        } catch (error) {
            throw error.response?.data || error;
        }
    }

    static async updateUserData(userData) {
        try {
            const formData = new FormData();
            
            Object.keys(userData).forEach(key => {
                if (key !== 'photo_document' && key !== 'photo_with_document') {
                    formData.append(key, userData[key]);
                }
            });

            if (userData.photo_document) {
                formData.append('photo_document', userData.photo_document);
            }
            if (userData.photo_with_document) {
                formData.append('photo_with_document', userData.photo_with_document);
            }

            const response = await axios.post(
                `${process.env.REACT_APP_API_BASE_URL}/users/update`,
                formData,
                {
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'multipart/form-data',
                        'Authorization': `Bearer ${StorageService.getAuth()?.token ?? ''}`
                    }
                }
            );
            return response.data;
        } catch (error) {
            throw error.response?.data || error;
        }
    }
}

export default UserHttpService;
